export const backendMaintenanceMessages = {
  'zh-CN': {
    label: '服务状态', badge: '暂时不可用', title: '网站维护中',
    description: '部分在线功能暂时不可用，请稍后再访问。',
    local: '本地识别与记录可继续使用。', recovery: '可稍后点击重新检测',
    retry: '重新检测', checking: '正在检测…', retryCountdown: '重新检测（{seconds}秒）', restored: '服务已恢复，控制面板已更新。',
  },
  'zh-TW': {
    label: '服務狀態', badge: '暫時無法使用', title: '網站維護中',
    description: '部分線上功能暫時無法使用，請稍後再造訪。',
    local: '本機辨識與記錄可繼續使用。', recovery: '可稍後點擊重新檢查',
    retry: '重新檢查', checking: '正在檢查…', retryCountdown: '重新檢查（{seconds}秒）', restored: '服務已恢復，控制面板已更新。',
  },
  en: {
    label: 'Service status', badge: 'Temporarily unavailable', title: 'Under maintenance',
    description: 'Some online features are temporarily unavailable. Please try again later.',
    local: 'Local recognition and recording remain available.', recovery: 'You can check again later',
    retry: 'Check again', checking: 'Checking…', retryCountdown: 'Check again ({seconds}s)', restored: 'Service restored. The dashboard has been updated.',
  },
  ja: {
    label: 'サービス状況', badge: '一時利用不可', title: 'メンテナンス中',
    description: '一部のオンライン機能を一時的に利用できません。しばらくしてから再度アクセスしてください。',
    local: 'ローカルでの認識と記録は引き続き利用できます。', recovery: 'しばらくしてから再確認できます',
    retry: '再確認', checking: '確認中…', retryCountdown: '再確認（{seconds}秒）', restored: 'サービスが復旧し、ダッシュボードを更新しました。',
  },
  ko: {
    label: '서비스 상태', badge: '일시 이용 불가', title: '사이트 점검 중',
    description: '일부 온라인 기능을 일시적으로 이용할 수 없습니다. 잠시 후 다시 방문해 주세요.',
    local: '로컬 인식과 기록은 계속 이용할 수 있습니다.', recovery: '잠시 후 다시 확인할 수 있습니다',
    retry: '다시 확인', checking: '확인 중…', retryCountdown: '다시 확인 ({seconds}초)', restored: '서비스가 복구되어 대시보드가 업데이트되었습니다.',
  },
} as const
